import { memo } from 'react';
import { Box, Skeleton } from '@betty/moonlight';

function PaymentMethodVerificationCardsSkeleton() {
  return (
    <Box
      flex={1}
      paddingTop="space-400"
      paddingBottom="safe-area-inset-bottom"
      paddingHorizontal="space-600"
    >
      <Skeleton height={60} />
      <Box gap="space-200" paddingVertical="space-400">
        <Skeleton height={70} />
        <Skeleton height={70} />
        <Skeleton height={70} />
      </Box>
      <Box flex={1} justifyContent="flex-end" gap="space-400">
        <Skeleton height={56} />
        <Skeleton height={56} />
      </Box>
    </Box>
  );
}

export default memo(PaymentMethodVerificationCardsSkeleton);
